module.exports = __webpack_public_path__ + "static/img/honor23.e9918c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor23.png
// module id = uCjI
// module chunks = 0